import SupplierAppConnectionCard from './SupplierAppConnectionCard'

export default SupplierAppConnectionCard
